(() => {
  const cards = [...document.querySelectorAll('.quick-launch')];
  const toggle = document.querySelector('.launch-motion-toggle');
  if (!toggle || !cards.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches || Boolean(navigator.connection?.saveData);
  let visible = new Set();
  function update() {
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
    cards.forEach(card => {
      const run = !paused && !document.hidden && visible.has(card);
      card.classList.toggle('is-playing', run);
      const video = card.querySelector('video');
      if (!video) return;
      if (run) {
        if (!video.src) video.src = video.dataset.src;
        video.play().catch(() => {});
      } else video.pause();
    });
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => isIntersecting ? visible.add(target) : visible.delete(target));
    update();
  }, {threshold: .15});
  cards.forEach(card => observer.observe(card));
  toggle.addEventListener('click', () => { paused = !paused; update(); });
  reduced.addEventListener('change', () => { paused = reduced.matches; update(); });
  document.addEventListener('visibilitychange', update);
  let beat = 0;
  setInterval(() => {
    if (paused || document.hidden) return;
    beat++;
    cards.forEach((card, index) => {
      if (!visible.has(card)) return;
      const frames = [...card.querySelectorAll('.launch-frame')];
      if (!frames.length) return;
      const frameIndex = card.classList.contains('quick-launch--prompt') ? beat % frames.length : (beat + (index === 3 ? 1 : 0)) % frames.length;
      frames.forEach((frame, i) => frame.classList.toggle('is-active', i === frameIndex));
      const example = card.querySelector('.launch-prompt');
      if (example) example.classList.toggle('is-hidden', beat % 2 !== 0);
    });
  }, 4200);
  update();
})();
